<template>
  <div class="root-APPKey" v-loading="loading">
    <!-- 搜索栏 -->
    <div class="search-sty">
      <el-form size="small" :inline="true" v-if="ifAppKey">
        <el-form-item>
          <el-button type="primary" plain @click="dialogVisible = true"
            >appkey备注</el-button
          >
        </el-form-item></el-form
      >
      <div v-else>
        <slot name="sss"></slot>
      </div>
      <el-form size="small" :inline="true" :model="formInline">
        <el-form-item v-if="ifAppKey">
          <el-select v-model="formInline.appkey" placeholder="请选择APPKEY">
            <el-option
              v-for="{ appkey, remark } of keyList"
              :key="appkey"
              :label="appkey"
              :value="appkey"
              >{{ `${remark ? `( ${remark} )` : ""} ${appkey}` }}</el-option
            >
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            style="width: 170px"
            v-model="formInline.startDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="开始日期"
            :picker-options="startPickerOptions"
            @change="startChange"
          >
          </el-date-picker>
          ~
          <el-date-picker
            style="width: 170px"
            v-model="formInline.endDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="结束日期"
            :picker-options="endPickerOptions"
            @change="endChange"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item style="margin-right:0px">
          <el-button style="margin-left: 10px" @click="getConsumption"
            >查询</el-button
          >
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="res-list">
      <el-empty
        v-show="consumption.length == 0"
        description="暂无数据"
        style="margin:0 auto"
      ></el-empty>
      <div
        v-show="consumption.length > 0"
        class="box-card"
        v-for="(item, i) of consumption"
        :key="i"
      >
        <p>{{ item.assetName }}</p>
        <p style="color: #ec1c1c">{{ item.cnt }}</p>
      </div>
    </div>
    <!-- 备注弹窗 -->
    <el-dialog
      title="APPKEY备注设置"
      :visible.sync="dialogVisible"
      width="480px"
    >
      <el-form
        v-for="item of keyList"
        :key="item.appkey"
        size="small"
        label-position="left"
        label-width="225px"
      >
        <el-form-item :label="item.appkey">
          <el-input
            placeholder="请填写备注"
            clearable
            style="width:200px"
            v-model="item.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="small"
          type="primary"
          :loading="btnLoading"
          @click="saveRemark"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { ApiMethods } from "../../../assets/js/http-serve/http-methods";

export default {
  name: "APPKey",
  props: {
    ifAppKey: { //appKey
      type: Boolean,
      default: true,
    },
    grantorUserId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      btnLoading: false,
      dialogVisible: false,
      formInline: {
        APPKEY: "",
        startDate: "",
        endDate: ""
      },
      keyList: [],
      consumption: [],
      startPickerOptions: {
        disabledDate: time => {
          return (
            moment(time) < moment().subtract(3, "y") || moment(time) > moment()
          );
        }
      },
      endPickerOptions: {
        disabledDate: time => {
          return (
            moment(time) < moment().subtract(3, "y") || moment(time) > moment()
          );
        }
      }
    };
  },
  // data end
  methods: {
    startChange(val) {
      this.endPickerOptions.disabledDate = time => {
        // 如果先选开始时间 就改变结束时间( + 1years)的禁用日期
        // 结束时间(+ 1years)是否 < 当前时间
        let isThen = moment(val)
          .add(1, "y")
          .isBefore(moment());
        return (
          moment(time) < moment(val) ||
          moment(time) > (isThen ? moment(val).add(1, "y") : moment())
        );
      };
    },
    endChange(val) {
      this.startPickerOptions.disabledDate = time => {
        // 如果先选结束时间 就改变开始时间(- 1years)的禁用日期
        return (
          moment(time) < moment(val).subtract(1, "y") ||
          moment(time) > moment(val)
        );
      };
    },
    /** 查询所有的appkey */
    getALLKey() {
      this.loading = true;
      ApiMethods.accountCenter
        .appkeyAll()
        .then(res => {
          if (!res.success) return this.$message.error(res.description);
          this.keyList = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 重置
    reset() {
      this.formInline = {
        APPKEY: "",
        startDate: "",
        endDate: ""
      };
      this.getConsumption();
    },
    /** 查询统计 */
    getConsumption() {
      let { appkey, startDate, endDate } = this.formInline;
      const param = { appkey, startDate, endDate };
      if (this.ifAppKey) {
        ApiMethods.accountCenter.appkeyConsumption(param).then(res => {
          if (!res.success) return this.$message.error(res.description);
          this.consumption = res.data ? res.data : [];
        });
      } else {
        let param1 = {
          grantorUserId: this.grantorUserId,
          startDate,
          endDate,
        }
        ApiMethods.IdenAuthController.consumptionList(param1).then(res => {
          if (!res.success) return this.$message.error(res.description);
          this.consumption = res.data ? res.data : [];
        });
      }
    },
    /** 保存备注 */
    saveRemark() {
      this.btnLoading = true;
      ApiMethods.accountCenter
        .updateAllRemark(this.keyList)
        .then(res => {
          if (!res.success) return this.$message.error(res.description);
          this.keyList = res.data;
          this.getALLKey();
          this.dialogVisible = !this.dialogVisible;
        })
        .finally(() => {
          this.btnLoading = false;
        });
    }
  },
  // methods end
  created() {
    this.getALLKey();
    this.getConsumption();
  }
};
</script>

<style scoped lang="less">
.root-APPKey {
  padding: 20px 25px 5px 25px;
  .search-sty {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .res-list {
    height: 59vh;
    border: 1px solid #ccc;
    padding: 15px 0;
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    overflow-y: auto;
  }
  .box-card {
    width: 185px;
    height: 120px;
    margin: 0 0 20px 18px;
    text-align: center;
    border: 1px solid #e9e9e9;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 4px;
    &:hover {
      box-shadow: 0px 0px 6px 0px #ccc;
    }
    > p {
      font-size: 17px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// pages/signSettings/components/APPKey.vue